import { httpsCallable } from 'firebase/functions';
import { getFunctionsClient } from './app';

/**
 * Typed callable wrapper. Usage:
 *   const verifyAdmin = callable<void, { isAdmin: boolean }>('verifyAdmin');
 *   const result = await verifyAdmin();
 */
export function callable<TIn, TOut>(
  name: string,
): (data?: TIn) => Promise<TOut> {
  const fn = httpsCallable<TIn, TOut>(getFunctionsClient(), name);
  return async (data?: TIn) => {
    const result = await fn(data as TIn);
    return result.data;
  };
}
